import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../common/Checkbox';
import { downloadDocument } from '../../../utils/exportHelper';
import { format } from 'date-fns';
import styles from './ProductsFeedsTable.module.scss';
import { ProductsFeedRowAdditionalInfo } from './ProductsFeedRowAdditionalInfo';

function getSuccessPercentage(row) {
  return (
    ((row.created_count + row.updated_count) / (row.created_count + row.updated_count + row.failed_count)) *
    100
  ).toFixed(2);
}

export function ProductsFeedRow({ row, checked, onChange, isEvenClassName }) {
  const downloadReport = () => {
    downloadDocument(row.report_url);
  };

  return (
    <tr key={row.batch_id} className={isEvenClassName}>
      <td>
        <Checkbox value={row.batch_id} hideLabel checked={checked} onChange={onChange} />
      </td>
      <td>{row.batch_id}</td>
      <td>{format(new Date(row.finished_at), 'dd MMM yyyy HH:mm')}</td>
      <td>{row.created_count}</td>
      <td>{row.updated_count}</td>
      <td>{row.failed_count}</td>
      <td>{getSuccessPercentage(row)}%</td>
      <td>
        <div className={styles.actionsCell}>
          <button onClick={downloadReport}>Download</button>
          <ProductsFeedRowAdditionalInfo row={row} />
        </div>
      </td>
    </tr>
  );
}

ProductsFeedRow.propTypes = {
  row: PropTypes.shape({
    batch_id: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    started_at: PropTypes.string.isRequired,
    finished_at: PropTypes.string.isRequired,
    created_count: PropTypes.number,
    updated_count: PropTypes.number,
    failed_count: PropTypes.number,
    report_url: PropTypes.string,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isEvenClassName: PropTypes.string,
};
